import React from 'react'
import SkeletonLoader from './SkeletonLoader'

const LoadingFallback: React.FC = () => {
  return (
    <div className='loader-fallback' style={{
      minHeight: '400px',
      padding: '20px'
    }}>
      <SkeletonLoader />
    </div>
  )
}

export default LoadingFallback
